import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  type?: 'website' | 'article';
}

const defaultTitle = 'Antonio Michal Verdile – Software Engineer';
const defaultDescription = 'Software engineer specializing in full-stack web development with expertise in React, TypeScript, C#, and .NET. Proven track record delivering scalable enterprise applications for Swiss National Bank and academic research projects.';
const siteUrl = process.env.REACT_APP_SITE_URL || 'https://your-domain.vercel.app';
const defaultImage = `${siteUrl}/og.svg`;

export const SEO: React.FC<SEOProps> = ({
  title = defaultTitle,
  description = defaultDescription,
  canonical,
  ogImage = defaultImage,
  type = 'website'
}) => {
  const fullTitle = title === defaultTitle ? title : `${title} – Antonio Michal Verdile`;
  const canonicalUrl = canonical || siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Antonio Michal Verdile" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
